var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fake-wrap" },
    [
      _c(
        "div",
        { staticClass: "products__goods" },
        _vm._l(_vm.items, function (item) {
          return _c("catalogitem", { key: item.id, attrs: { item: item } })
        }),
        1
      ),
      _vm.pageCount > 0
        ? _c("pagination", {
            attrs: { pageCount: _vm.pageCount, activePage: _vm.activePage },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }